import { ITrainingDocument } from '../models/training-document.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function listing(query?: IPaginationQuery) {
  return request<IPaginationData<ITrainingDocument>>({
    url: '/document',
    params: query,
    method: 'GET',
  });
}

function getDetail(id: string) {
  return request<ITrainingDocument>({
    url: `/document/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<ITrainingDocument>) {
  return request<ITrainingDocument>({
    url: `/document`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<ITrainingDocument>) {
  return request<ITrainingDocument>({
    url: `/document/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<ITrainingDocument>({
    url: `/document/${id}`,
    method: 'DELETE',
  });
}

const documentApi = Object.freeze({
  listing,
  create,
  getDetail,
  remove,
  update,
});

export default documentApi;
